module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-FXPBK68Z83"],"pluginConfig":{"head":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ACO Srbija i Crna Gora","short_name":"ACO Showroom","start_url":"/","background_color":"#fff","theme_color":"#1e3e5e","display":"standalone","icon":"static/aco-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"e92a2e2434ce647f25b39844c8d9c522"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
